import './DirectChatDayDivider.css';

export type DirectChatDayDividerProps = {
  label: string;
  /** false для «Сегодня» — бейдж не липнет к верху viewport */
  sticky: boolean;
};

export function DirectChatDayDivider({ label, sticky }: DirectChatDayDividerProps) {
  return (
    <div
      className={['directChatDayDivider', sticky && 'directChatDayDivider--sticky']
        .filter(Boolean)
        .join(' ')}
      role="separator"
      aria-label={label}
    >
      <span className="directChatDayDivider__pill">{label}</span>
    </div>
  );
}
